import { getReadonlyListItemDate, getReadonlyListItemId } from '@interxfi/app-components/components/readonly-list/util';
import type { ReadonlyListItemRecord } from '@interxfi/design-system/components/list/readonly/item/readonly-list-item';
import type { IxcFundingV1FundingTransaction } from '@interxfi/types/generated/api';
import { getPortfolioHoldDetailPath } from '../portfolio/hold/portfolio-hold-routing';
import { getRegistrationAccountDetailPath } from '../registration/account/registration-account-routing';
import { getProgramDetailPath } from '../userauth/program/program-routing';
import { getFundingTransferSpecListItems } from './transfer/funding-transfer-list-items';
import { getFundingTransferDetailPath } from './transfer/funding-transfer-routing';

export function getFundingTransactionListItems(data: IxcFundingV1FundingTransaction | undefined, prefix = '') {
  return {
    fundingId: getReadonlyListItemId(
      `${prefix}fundingId`,
      'Funding ID',
      data?.fundingId,
      getFundingTransferDetailPath(data?.fundingId, data?.accountId),
    ),
    accountId: getReadonlyListItemId(`${prefix}accountId`, 'Account ID', data?.accountId, getRegistrationAccountDetailPath(data?.accountId)),
    programId: getReadonlyListItemId(`${prefix}programId`, 'Program ID', data?.programId, getProgramDetailPath(data?.programId)),
    timestamp: getReadonlyListItemDate(`${prefix}timestamp`, 'Timestamp', data?.timestamp, 'timestamp_iso_ms'),
    transfer: getFundingTransferSpecListItems(data?.transfer, `${prefix}transfer.`),
    holdId: data?.holdId
      ? getReadonlyListItemId(`${prefix}holdId`, 'Hold ID', data.holdId, getPortfolioHoldDetailPath(data?.accountId, data.holdId))
      : undefined,
  } as const satisfies ReadonlyListItemRecord;
}
